import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["vatinField", "vatinPayerCheckbox"];

  toggleVatinField() {
    if (this.vatinPayerCheckboxTarget.checked) {
      this.vatinFieldTarget.classList.remove("hidden");
    } else {
      this.vatinFieldTarget.classList.add("hidden");
      this.vatinFieldTarget.querySelector("input").value = "";
    }
  }
}
